import AppLayout from '@/components/layout/AppLayout';
import KanbanBoard from '@/components/crm/KanbanBoard';
import CaseDetailModal from '@/components/crm/CaseDetailModal';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

const Cases = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">CRM Cases</h1>
            <p className="text-muted-foreground">
              Manage debtor cases through operational workflow
            </p>
          </div>
          
          <div className="relative w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search cases..."
              className="pl-9"
            />
          </div>
        </div>

        <KanbanBoard />
        <CaseDetailModal />
      </div>
    </AppLayout>
  );
};

export default Cases;
